import React from 'react';
export function UrgencySection() {
  return <section className="w-full bg-black" data-id="element-138">
      {/* Top gold line */}
      <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#C5A014]/40 to-transparent" data-id="element-139" />

      <div className="py-16 md:py-20 px-4 text-center max-w-3xl mx-auto space-y-4" data-id="element-140">
        <p className="font-['Crimson_Text'] text-sm md:text-base tracking-[0.2em] uppercase text-zinc-400" data-id="element-141">
          Actualizado a marzo 2026
        </p>
        <p className="font-['Crimson_Text'] text-lg md:text-xl text-zinc-200 leading-relaxed" data-id="element-142">
          Capturado el 13 de marzo de 2026. Este libro reconstruye toda la
          historia hasta el día de su traslado a Estados Unidos.
        </p>
      </div>

      {/* Bottom gold line */}
      <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#C5A014]/40 to-transparent" data-id="element-143" />
    </section>;
}